// extracted by mini-css-extract-plugin
export default {"sliderInfoDark":"SliderInfo_sliderInfoDark__soOcK","text":"SliderInfo_text__qs1Vi","sliderInfoLight":"SliderInfo_sliderInfoLight__2oC8J"};